// Code review - Completed
// Documentation - Completed
import { useState, useEffect } from "react";
import GridPage from "../components/GridPage";
import { useLocation } from "react-router-dom";
import MainLayout from "../components/MainLayout";
import { doctorAppoinmentsHeaders } from "../components/HeaderAttribute";
// import { BindPostAPI } from "../services/APIConnection";
import { useUserCapability } from "../components/ConstantReducerProvider";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
import toast from "react-hot-toast";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";

const DoctorAppointments = () => {
  const location1 = useLocation();
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  //All visible functionality useState hooks handling.
  const [isLoading, setIsLoading] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);

  useEffect(() => {
    BindGridData();
    if (location1.pathname == "/doctorappointments") {
      setVisibleTable(true);
    }
  }, [location1, userProfileDatas]);

  const doctorConsultationHeadersExport = [
    { title: "S.No.", key: "sno", width: 10 },
    { title: "TxnDrAppoinmentId", key: "TxnDrAppoinmentId", width: 30 },
    { title: "Client Id", key: "ClientId", width: 30 },
    { title: "Client Name", key: "ClientName_en", width: 30 },
    { title: "Gender / Age", key: "ClientGenderAge_en", width: 20 },
    { title: "Phone", key: "ClientPhoneNo", width: 20 },
    { title: "Appointment", key: "LocationName_en", width: 35 },
    { title: "Created By", key: "CreatedByName", width: 25 },
  ];
  
  const exportDoctorConsultationData = (headers, rows) => {
    // Title
    const titleRow = [
      {
        v: "Doctor Consultation Report",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];
  
    // Header row
    const headerRow = headers.map((column) => ({
      v: column.title,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));
  
    // Data rows
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
  
      const rowStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};
  
      return headers.map((col) => {
        if (col.key === "sno") {
          return {
            v: index + 1,
            s: rowStyle,
          };
        }
  
        return {
          v: rowData[col.key] ?? "",
          s: rowStyle,
        };
      });
    });
  
    const wsData = [titleRow, headerRow, ...dataRows];
  
    const ws = XLSX.utils.aoa_to_sheet(wsData);
  
    // Dynamic column widths
    ws["!cols"] = headers.map((col) => ({
      width: col.width || 25,
    }));
  
    // Row heights
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 20 },
      ...Array(rows.length).fill({ hpt: 18 }),
    ];
  
    // Borders
    const range = XLSX.utils.decode_range(ws["!ref"]);
  
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
  
        if (!ws[cellRef]) continue;
  
        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }
  
    const wb = XLSX.utils.book_new();
  
    XLSX.utils.book_append_sheet(wb, ws, "Doctor Consultation");
  
    XLSX.writeFile(wb, "Doctor_Consultation.xlsx");
  
    toast.success("Excel exported successfully 👍");
  };
  
  // const handleDoctorConsultationExport = async () => {
  //   try {
  //     const [profile] = userProfileDatas;
  
  //     const payload = {
  //       mstOrganizationStructureId: profile.MstOrganizationId,
  //       mstBranchId: profile.MstLocationId,
  //       mstSdpId: profile.MstSDPId ?? 0,
  //       mstUserId: profile.MstUserId,
  //       mstRoleId: profile.MstRoleId,
  //     };
  
  //     const response = await BindPostAPI(
  //       payload,
  //       "DoctorConsultation/BindDoctorConsultation"
  //     );
  
  //     const rows = response?.data?.Table || [];
  
  //     if (rows.length === 0) {
  //       toast.error("No data available to export");
  //       return;
  //     }
  
  //     exportDoctorConsultationData(
  //       doctorConsultationHeadersExport,
  //       rows
  //     );
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Export failed");
  //   }
  // };

  const handleDoctorConsultationExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");
  
    try {
      const [profile] = userProfileDatas;
  
      const payload = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0,
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
      };
  
      const response = await BindPostAPI(
        payload,
        "DoctorConsultation/BindDoctorConsultation"
      );
  
      const rows = response?.data?.Table || [];
  
      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "DOCTOR CONSULTATION",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "txn_doctor_consultation",
            description: "No data available to export",
          },
          "Log/IUDLog"
        );
  
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
  
        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "DOCTOR CONSULTATION",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "txn_doctor_consultation",
            description: `Doctor Consultation Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog"
        );
      }
  
      exportDoctorConsultationData(
        doctorConsultationHeadersExport,
        rows
      );
    } catch (error) {
      console.error(error);
  
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "DOCTOR CONSULTATION",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "txn_doctor_consultation",
          description: error?.message || "Doctor Consultation export failed",
        },
        "Log/IUDLog"
      );
  
      toast.error("Export failed", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const BindGridData = async () => {
    debugger
    if (userProfileDatas && userProfileDatas[0]) {
      try {
        setIsLoading(true);
        const payload = {
          mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
          mstBranchId: userProfileDatas[0].MstLocationId,
          mstSdpId: userProfileDatas[0].MstSDPId
            ? userProfileDatas[0].MstSDPId
            : 0,
          mstUserId: userProfileDatas[0].MstUserId,
          mstRoleId: userProfileDatas[0].MstRoleId,
        };
        const response = await BindPostAPI(
          payload,
          "DoctorConsultation/BindDoctorConsultation"
        );
        setBindAppoinmentsDatas(response.data.Table);
      } catch (error) {
        console.error("Error loading doctor appointments:", error);
      } finally {
        setIsLoading(false); // loader stop (success/error both cases)
      }
    }
  };


  
  const [bindAppointmentsDatas, setBindAppoinmentsDatas] = useState([]);

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={"Doctor Consultation"}
          xScroll="overflow-x-auto max-md:w-fit w-full"
          tableScroll="relative z-0 flex flex-col md:block hidden border text-sm text-left text-gray-500 w-full md:min-w-fit"
          header={doctorAppoinmentsHeaders}
          records={bindAppointmentsDatas}
          handleExportBtn={true}
          handleExport={handleDoctorConsultationExport}
          addView={true}
        />
      )}
    </MainLayout>
  );
};

export default DoctorAppointments;
